import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { SrIcon } from "@/components/ui/SrIcon";

interface Props {
  approveOnSave: boolean;
  onApproveOnSaveChange: (checked: boolean) => void;
  onApproveDirectly: () => void;
  isApproving: boolean;
  /** Ulagede endringer — godkjenning krever lagring først. */
  approveDisabled?: boolean;
  approveDisabledReason?: string;
}

export function UpsellApprovalBox({
  approveOnSave,
  onApproveOnSaveChange,
  onApproveDirectly,
  isApproving,
  approveDisabled = false,
  approveDisabledReason,
}: Props) {
  return (
    <div className="border border-amber-200 bg-amber-50/50 rounded-md p-3 space-y-2">
      <div className="flex items-start gap-2">
        <SrIcon name="info" className="w-4 h-4 text-amber-700 mt-0.5 shrink-0" />
        <div className="flex-1 text-sm">
          <p className="text-amber-900 font-medium">Dette mersalget er et utkast</p>
          <p className="text-amber-800 text-xs mt-0.5">
            Utkast teller ikke i GEEK eller på fakturalisten. Godkjenn når kunden har bekreftet.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Checkbox
          id="approve-on-save"
          checked={approveOnSave}
          onCheckedChange={(c) => onApproveOnSaveChange(c === true)}
          disabled={approveDisabled}
        />
        <Label htmlFor="approve-on-save" className="text-xs cursor-pointer">
          Godkjent av kunde direkte (hopper over utkast-steget)
        </Label>
      </div>
      {approveOnSave && (
        <Button
          size="sm"
          onClick={onApproveDirectly}
          disabled={isApproving || approveDisabled}
          title={approveDisabled ? approveDisabledReason : undefined}
          className="w-full"
        >
          {isApproving ? (
            <SrIcon name="loader2" className="w-3 h-3 mr-1 animate-spin" />
          ) : (
            <SrIcon name="check" className="w-3 h-3 mr-1" />
          )}
          Godkjenn nå
        </Button>
      )}
      {approveDisabled && approveDisabledReason && (
        <p className="text-[11px] text-amber-800">{approveDisabledReason}</p>
      )}
    </div>
  );
}
